import { createFileRoute } from '@tanstack/react-router';
import usePersonParams from '@/routes/_staff/person/$id/-hooks/usePersonParams';
import { LARGE_CATEGORY_CODES, SectionFormWrapper, prefetchPeopleLedgerDetail } from '@/routes/_staff/person/$id/_profile/-shared';
export const Route = createFileRoute('/_staff/person/$id/_profile/board-member-information/')({
  component: BoardMemberInformation,
  loader: ({
    params
  }) => prefetchPeopleLedgerDetail(params.id, LARGE_CATEGORY_CODES.BOARD_MEMBER_INFORMATION)
});
function BoardMemberInformation() {
  const {
    id
  } = usePersonParams();
  return <SectionFormWrapper personId={id} largeCategoryCode={LARGE_CATEGORY_CODES.BOARD_MEMBER_INFORMATION} linkTo="/person/$id/board-member-information" />;
}